import { render } from "./ToolDeleteModal.vue?vue&type=template&id=d8c3d3d4"
import script from "./ToolDeleteModal.vue?vue&type=script&lang=js"
export * from "./ToolDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__